import React from "react";
import "./BodySite.css"
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import PageTitles from "./PageTitles";


const TurnosLicenciasMenu = () => {
    const navigate = useNavigate();

    const clickHandler = (e) =>{
        localStorage.setItem("Licencias-Sel",e)
        navigate("/turnoslicenciasmenucontinuar");
        
    }

    
    return (
        <>
       <div class="container text-center indexContent" >
            {/*<div class="row">
                <div class="col">
                    <h1 class="titleIndicator">
                    <img class="imgBackIcon" src="./back-go.svg" onClick={()=>{navigate("/turnosdocumentacionmenu")}}/> Licencias</h1>
                </div>
    </div>*/}
    <PageTitles texto="Turnos" subtexto="Licencias" icono="./icon_header_turnos.svg" retorno="/turnosdocumentacionmenu"/>
            <div class="row">
                <div class="col">
                <div className="buttonContainer">
                <button className="buttonInvertedClip" onClick={()=> clickHandler("Original|978")}>Original</button>
                </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                <div className="buttonContainer">
                    <button className="buttonInvertedClip" onClick={()=> clickHandler("Renovación|979")}>Renovaci&oacute;n</button>
               </div> 
                </div>
            </div>
            <div class="row">
                <div class="col">
                <div className="buttonContainer">
                    <button className="buttonInvertedClip" onClick={()=> clickHandler("Profesional|980")}>Profesional</button>
               </div> 
                </div>
            </div>
            <div class="row">
                <div class="col">
                <div className="buttonContainer">
                <button className="buttonInvertedClip" onClick={()=> clickHandler("Ampliación|2260")}>Ampliaci&oacute;n</button>
                </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                <div className="buttonContainer">
                    <button className="buttonInvertedClip" onClick={()=> clickHandler("Renovación - Sede Km46|2195")}>Renovaci&oacute;n - Sede Km46</button>
               </div> 
                </div>
            </div>
            <div class="row">
                <div class="col">
                <div className="buttonContainer">
                    <button className="buttonInvertedClip" onClick={()=> clickHandler("Renovación - Sede Del Viso|3610")}>Renovaci&oacute;n - Sede Del Viso</button>
               </div> 
                </div>
            </div>
            
           
       </div>
        
        </>

    );
}

export default TurnosLicenciasMenu;